import { HeartIcon } from '@heroicons/react/24/outline';
import { I18N_NAMESPACES } from 'i18n';
import { useTranslation } from 'i18n/hooks';
import { isBrowserEnv } from 'modules/common/utils/env';
import { useEffect, useState } from 'react';
import { MarketplaceAPI } from 'revibe-api';
import { Button } from 'revibe-ui';

interface Props {
  article: MarketplaceAPI.BlogArticle & {
    likes: number;
    previous?: MarketplaceAPI.BlogArticle | null;
    next?: MarketplaceAPI.BlogArticle | null;
  };
}

export const BlogLikesButton = ({ article }: Props) => {
  const { tu } = useTranslation(I18N_NAMESPACES.BLOG);
  const [likes, setLikes] = useState<string[]>([]);
  const hasLikedTheArticle = likes.includes(article.slug);

  useEffect(() => {
    if (isBrowserEnv()) {
      const serializedState =
        window.localStorage &&
        window.localStorage.getItem('revibe-user-article-likes');
      if (serializedState !== null) {
        setLikes(JSON.parse(serializedState) as string[]);
      }
    }
  }, []);

  const toggleLike = async () => {
    if (hasLikedTheArticle) {
      setLikes(likes.filter((l) => l !== article.slug));
      if (isBrowserEnv()) {
        window.localStorage &&
          window.localStorage.setItem(
            'revibe-user-article-likes',
            JSON.stringify(likes.filter((l) => l !== article.slug))
          );
      }
      await MarketplaceAPI.updateDBBlogArticle(article.slug, {
        slug: article.slug,
        likes: article.likes - 1,
      });
    } else {
      setLikes([...likes, article.slug]);
      if (isBrowserEnv()) {
        window.localStorage &&
          window.localStorage.setItem(
            'revibe-user-article-likes',
            JSON.stringify([...likes, article.slug])
          );
      }
      await MarketplaceAPI.updateDBBlogArticle(article.slug, {
        slug: article.slug,
        likes: article.likes + 1,
      });
    }
  };

  if (likes.includes(article.slug)) {
    <Button onClick={toggleLike} className="text-sm">
      <HeartIcon className="mr-2 h-5 w-5 stroke-white" /> {tu('like')} (
      {article.likes + 1})
    </Button>;
  }

  return (
    <Button variant="outline" onClick={toggleLike} className="text-sm">
      <HeartIcon className="mr-2 h-5 w-5" /> {tu('like')} ({article.likes})
    </Button>
  );
};
